var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.23C0 39.7896 6.9511 49.7203 16.8978 54.0864C16.8185 52.1152 16.8837 49.7487 17.3892 47.6039C17.932 45.3123 21.0216 32.2215 21.0216 32.2215C21.0216 32.2215 20.1198 30.4189 20.1198 27.755C20.1198 23.5715 22.5444 20.4471 25.5641 20.4471C28.1319 20.4471 29.3725 22.3757 29.3725 24.6852C29.3725 27.2665 27.7261 31.1276 26.8794 34.7037C26.1722 37.6982 28.3809 40.1407 31.3351 40.1407C36.6837 40.1407 40.2861 33.271 40.2861 25.1316C40.2861 18.9445 36.1189 14.3135 28.5395 14.3135C19.9762 14.3135 14.6415 20.6996 14.6415 27.8328C14.6415 30.2924 15.3666 32.0267 16.5024 33.3698C17.0247 33.9867 17.0972 34.2348 16.9082 34.9432C16.7728 35.4626 16.4618 36.713 16.333 37.2086C16.1451 37.9236 15.5658 38.1792 14.9196 37.9152C10.9754 36.305 9.13845 31.9857 9.13845 27.1302C9.13845 19.111 15.9016 9.49529 29.3142 9.49529C40.0922 9.49529 47.186 17.2946 47.186 25.6667C47.186 36.7408 41.0293 45.0141 31.9539 45.0141C28.9062 45.0141 26.0394 43.3666 25.0573 41.4953C25.0573 41.4953 23.4184 47.9996 23.0713 49.2556C22.4728 51.4321 21.3012 53.6076 20.23 55.3031C22.8275 56.0711 25.5221 56.461 28.2307 56.4608C43.8196 56.4608 56.4594 43.8216 56.4594 28.23C56.4594 12.6391 43.8196 0 28.2307 0C12.6402 0 0 12.6391 0 28.23Z",
    fill: "#CB1F27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.4592,
    height: 56.4592,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest-icon.66497e4582d87363f9f6f92e181ff0d2.svg";
export { ForwardRef as ReactComponent };